import { IMAGES } from "./site";

export const COMPANIES = [
    {
        slug: "digon",
        route: "/companies/digon",
        cardTitle: "DIGON POWER",
        fullName: "PT DIGON POWER TRANSMISSION",
        category: "POWER TRANSMISSION",
        tagline: "Excellence in Every Line",
        heroTitle: "EXCELLENCE IN EVERY LINE",
        heroSubtitle: "Power Transmission Specialist",
        image: IMAGES.digon,
        logo: "/assets/logo-digon-transparent.png",
        cardImage: "https://images.unsplash.com/photo-1564415061701-26c564ecdc66?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxwb3dlciUyMHRyYW5zbWlzc2lvbiUyMHRvd2VycyUyMGJyaWdodCUyMHNreXxlbnwwfHx8fDE3OTE0NzY2MjZ8MA&ixlib=rb-4.1.0&q=85&w=1200&h=800&fit=crop",
        pdf: "/downloads/PT. Digon Power Transmission - Company Profile.pdf",
        pdfLabel: "PT. Digon Power Transmission - Company Profile.pdf",
        description:
            "A transmission-focused company delivering reliable power transmission infrastructure through proven execution, resilient workforce, and excellence in challenging environments.",
        cardCapabilities: [
            "High Voltage Transmission Lines",
            "Substation Development",
            "Civil Works",
            "Tower Erection",
            "Stringing & Installation",
            "Commissioning & Engineering",
            "Operations & Maintenance",
            "Project Support & Logistics",
        ],
        highlight: { value: "20+", label: "Years of Experience" },
        about: [
            "We are a transmission-focused company with over 20 years of proven experience, built on a strong and resilient workforce.",
            "Our core strength lies in executing projects in challenging and complex terrains, where precision, speed, and reliability are critical. We don't just build infrastructure — we ensure delivery with certainty.",
        ],
        vision: "To be a leading force in Indonesia's power transmission infrastructure, recognized for engineering excellence, execution strength, and uncompromising reliability.",
        mission: [
            "Deliver world-class transmission solutions with precision, consistency, and accountability.",
            "Leverage a highly resilient and experienced workforce as the foundation of operational excellence.",
            "Execute complex and high-risk projects across challenging terrains with superior capability.",
            "Uphold the highest standards of safety, quality, and compliance in every operation.",
            "Build long-term strategic partnerships with PLN, EPC contractors, and global stakeholders.",
            "Drive continuous innovation to enhance performance, efficiency, and project delivery.",
        ],
        strengths: [
            {
                title: "Resilient & Experienced Workforce",
                desc: "Highly trained teams with strong field adaptability.",
            },
            {
                title: "Expertise in Challenging Terrain",
                desc: "Proven capability in mountains, forests, and remote areas.",
            },
            {
                title: "Execution Excellence",
                desc: "Strong planning, fast mobilization, and precise delivery.",
            },
            {
                title: "Commitment to Safety & Quality",
                desc: "Zero accident mindset with strict compliance standards.",
            },
        ],
        services: [
            "Civil Works (foundation, access road, etc.)",
            "Tower Erection",
            "Stringing & Installation",
            "Project Support & Logistics",
            "Substation & Electromechanical",
            "Operations & Maintenance",
            "Commissioning & Engineering",
        ],
        projectIntro:
            "For over 20 years, we have delivered more than 100,000 transmission line and substation projects, including SUTT, SUTET, and substations — across all islands in Indonesia and Timor-Leste.",
        projects: [
            {
                name: "SUTET 500V Program",
                client: "PT Tehate",
                scope: "Kupang · NTT · Sampit · Pangkalan Bun · Gardu Induk Sampit · Gardu Induk Maumere · Cilacap",
            },
            {
                name: "SUTET Teluk Naga 500 KV",
                client: "PT Percie",
                scope: "Extra high voltage transmission line",
            },
            {
                name: "SUTT Pati – Rembang 150 KV",
                client: "PT Citacontractor",
                scope: "High voltage transmission line",
            },
        ],
        clientsNote:
            "Trusted by leading clients & partners across Indonesia's transmission sector.",
        experienceHighlights: [
            "20+ years of experience",
            "Transmission line and substation projects",
            "SUTT PLN built",
            "SUTET (Electrical Grid)",
            "Substations",
            "Challenging terrain",
            "Indonesia",
            "Timor-Leste",
        ],
        platforms: [
            { num: "01", name: "HIGH VOLTAGE TRANSMISSION LINES" },
            { num: "02", name: "SUBSTATION DEVELOPMENT" },
            { num: "03", name: "GRID EXPANSION PROJECTS" },
            { num: "04", name: "TESTING & COMMISSIONING" },
            { num: "05", name: "DATA CENTER POWER INFRASTRUCTURE" },
        ],
        contact: {
            email: "masriadli@digonpowertransmission.com",
            phones: ["+628-1758-1774"],
            address: "Komplek PP No. B6 Banyumanik-Semarang",
        },
    },
    {
        slug: "sadja-group",
        route: "/companies/sadja-group",
        cardTitle: "SADJA GROUP",
        fullName: "PT SADJA GROUP INDONESIA",
        category: "CONSTRUCTION & PROPERTY DEVELOPMENT",
        tagline: "Construction • Architecture • Infrastructure",
        heroTitle: "SADJA GROUP INDONESIA",
        heroSubtitle: "Construction • Architecture • Infrastructure",
        image: IMAGES.sadjaGroup,
        logo: "/assets/logo-sadja-group-transparent.png",
        cardImage: "https://images.unsplash.com/photo-1527335988388-b40ee248d80c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxicmlnaHQlMjBjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwZGF5dGltZSUyMG1pbmltYWx8ZW58MHx8fHwxNzkxNDc2NjQxfDA&ixlib=rb-4.1.0&q=85&w=1200&h=800&fit=crop",
        pdf: "/downloads/PT. Sadja Group Indonesia Company Profile.pdf",
        pdfLabel: "PT. Sadja Group Indonesia Company Profile.pdf",
        description:
            "A multidisciplinary Construction, Design Architecture & Electric Transmission development company delivering civil, commercial, residential, architectural, and transmission-related projects for clients across Indonesia.",
        cardCapabilities: [
            "Civil Construction",
            "Architectural Design",
            "Building Construction",
            "Foundation & Structural Works",
            "Land Filling & Compaction",
            "Transmission Construction",
            "Property Development",
        ],
        about: [
            "PT Sadja Group Indonesia holds competencies in construction services, architectural design, and electricity transmission — supported by an experienced management team and resources matched to their expertise, with extraordinary dedication to the field.",
            "We believe every responsibility entrusted to us will be resolved for our clients. We continue to develop innovation, raise quality, and collaborate through efficient work systems in every service we provide. Our core commitment is maintaining client trust and satisfaction through the performance of PT Sadja Group Indonesia.",
        ],
        specializations: [
            {
                title: "Civil Construction & Design",
                desc: "Foundation works, towers, fabrication, structural installation, building construction, and complete civil and architectural design works.",
            },
            {
                title: "Land Filling & Compaction",
                desc: "Land preparation and improvement for infrastructure projects — clearing, cutting, filling, and compaction of work areas.",
            },
            {
                title: "SUTT / SUTET Stringing & Erection",
                desc: "High-voltage conductor stringing and jointing executed to high safety standards and accuracy across varied terrain conditions.",
            },
            {
                title: "Building Construction",
                desc: "Commercial and residential building delivery, from structure to finishing.",
            },
            {
                title: "Architectural Design",
                desc: "Integrated architectural design services supporting construction and property development.",
            },
            {
                title: "Property Development",
                desc: "End-to-end property development from concept and planning to delivery.",
            },
        ],
        trackRecord: [
            "SUTT PLN — 20 years of experience as sub-contractor by Digon Power",
            "2024–2025 · Breakwater construction, Pantai Asem Doyong, KSO PT. Wahyu Jati Abadi (Pemalang)",
            "2024–2025 · SMA & SMK school building construction (Pemprov Jawa Tengah)",
            "2024–2025 · RUSUN revitalization & housing public facilities (Dinas Perumahan & Pemukiman Kota Semarang)",
            "2024–2025 · China Road and Bridge Construction (CRBC) — PP bamboo and boulder rock supply",
            "2024–2026 · Kalla project house (Makassar), KSO Jovanindo Perdana",
            "2024–2025 · 4 Branch Best PR (Semarang)",
        ],
        workAreas: [
            {
                region: "Jawa",
                detail: "Priok 500KV, 2022 · Water Break Pemalang · Tol Semarang–Demak · School Buildings · RUSUN & housing facilities",
            },
            { region: "Kalimantan", detail: "Gunung Mas 150KV, 2025" },
            {
                region: "Timor Leste",
                detail: "Dili 150KV, 2011–2014 (PT. Tehate) — Subcon by Digon Power",
            },
            { region: "Bangka Belitung", detail: "150KV, 2025" },
            {
                region: "Sulawesi",
                detail: "Kendari 150KV, 2025 · Kalla Project House",
            },
        ],
        partners: [
            "PT Indisi",
            "PT Ayama",
            "PT Kembar Abadi",
            "PT Karya Mitra Nugraha (KMN)",
            "PT Wahyu Jati Abadi",
            "PT Enviromate Technology International (ETI)",
            "PT Banda Karya Abadi",
            "CV Jovanindo Perdana",
            "PT Best PR",
        ],
        management: [
            { name: "Bito Leilia Atmadja", role: "Direktur Utama" },
            { name: "Dra. Nany Lestari, MM", role: "Komisaris" },
            { name: "Bambang Slamet Riyadi (Digon)", role: "Komisaris" },
            { name: "Drs. Abasari, M.Hum", role: "Komisaris" },
            { name: "Bima Eka Sakti", role: "Direktur Operasional 1" },
            { name: "Aris Maulana Akbar, M.Si", role: "Direktur Operasional 2" },
        ],
        legality:
            "PT Sadja Group Indonesia operates with complete company legality, Work Competency Certificates (Sertifikat Kompetensi Kerja), and Business Entity Certificates (Sertifikat Badan Usaha) — documented in the company profile.",
        experienceHighlights: [
            "Civil construction",
            "School construction",
            "Breakwater construction",
            "Housing / residential facilities",
            "Land supply and infrastructure support",
            "Transmission-related construction",
            "Commercial projects",
        ],
        platforms: [
            { num: "01", name: "HIGH QUALITY CIVIL WORK" },
            { num: "02", name: "HIGH QUALITY CIVIL COMMERCIAL" },
            { num: "03", name: "HIGH QUALITY CIVIL RESIDENTIAL" },
            { num: "04", name: "PROPERTY DEVELOPMENT" },
        ],
        contact: {
            email: "official@sadjacorecorp.com",
            secondaryEmail: "business@bitoatmadja.com",
            phones: ["+62 817-581-174", "+62 818-181-174"],
            address: "Komplek PP No. B6 Banyumanik-Semarang",
        },
    },
    {
        slug: "orbito",
        route: "/companies/orbito",
        cardTitle: "ORBITO",
        fullName: "PT ORBITO INTEGRATED ENERGY",
        category: "INTEGRATED ENERGY",
        tagline: "Integrated Solutions. Sustainable Future.",
        heroTitle: "ORBITO INTEGRATED ENERGY",
        heroSubtitle: "Integrated Energy Platform",
        image: IMAGES.orbito,
        logo: "/assets/logo-orbito-transparent.png",
        cardImage: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxzb2xhciUyMHBhbmVscyUyMGJyaWdodCUyMHNreSUyMG1pbmltYWx8ZW58MHx8fHwxNzkxNDc2NjQxfDA&ixlib=rb-4.1.0&q=85&w=1200&h=800&fit=crop",
        pdf: "/downloads/PT ORBITO - INTEGRATED ENERGY.pdf",
        pdfLabel: "PT ORBITO - INTEGRATED ENERGY.pdf",
        description:
            "The group's integrated power generation and energy platform — delivering innovative and integrated EPCC solutions for Indonesia's growing energy demands.",
        cardCapabilities: [
            "Pembangkit Listrik Tenaga Minyak Gas (PLTMG)",
            "Pembangkit Listrik Tenaga Surya (PLTS)",
            "Testing & Commissioning",
            "Operation & Maintenance",
            "Gas Power Plants (PLTMG)",
            "Oil & Gas Infrastructure Support",
            "Battery Energy Storage Systems (BESS)",
            "Civil, Mechanical and Electrical Construction",
            "Procurement and Supply Chain Management",
        ],
        about: [
            "PT. Orbito Integrated Energy (ORBITO) is a strategic entity under the umbrella of PT. Sadja Core Corp, a holding company dedicated to the development of energy and infrastructure businesses. ORBITO focuses on delivering innovative and integrated Engineering, Procurement, Construction, and Commissioning (EPCC) solutions, supported by a management team with decades of experience in large-scale power and energy infrastructure projects across Indonesia.",
            "ORBITO is the sister company of PT. Digon Power Transmission, a company with more than 20 years of proven expertise in High Voltage Transmission Lines (SUTT) and Extra High Voltage Transmission Lines (SUTET) across some of the most challenging terrains throughout Indonesia. This synergy enables ORBITO to combine deep transmission expertise with an expansive vision in the power generation and energy sector.",
            "We are committed to addressing Indonesia's growing energy demands by delivering solutions founded on quality, efficiency, innovation, and integrity. ORBITO is more than a contractor — we are a strategic partner dedicated to building the future of Indonesia's energy landscape.",
        ],
        vision: "To become a leading integrated energy company in Southeast Asia, developing, building, operating and owning strategic energy assets that power sustainable growth.",
        mission: [
            "Support industrial and utility customers.",
            "Deliver world-class EPCC and O&M services.",
            "Develop conventional and renewable power projects.",
            "Build a long-term portfolio of energy assets as an Independent Power Producer (IPP).",
        ],
        services: [
            "Gas Power Plants (PLTMG)",
            "Solar Power Plants (PLTS)",
            "Testing & Commissioning",
            "Operation & Maintenance",
            "Oil & Gas Infrastructure Support",
            "Battery Energy Storage Systems (BESS)",
            "Civil, Mechanical and Electrical Construction",
            "Procurement and Supply Chain Management",
        ],
        epcc: [
            {
                title: "Engineering",
                desc: "Highly skilled professionals across Civil, Electrical, Mechanical, and Instrumentation & Control disciplines, leveraging cutting-edge software and international standards (ASME, IEC, API).",
                items: [
                    "Feasibility Studies & Conceptual Design",
                    "Front-End Engineering Design (FEED)",
                    "Detailed Engineering Design (DED)",
                    "Value Engineering",
                ],
            },
            {
                title: "Procurement",
                desc: "A procurement strategy focused on efficiency, cost-effectiveness, and reliability.",
                items: [
                    "Global Sourcing & Vendor Management",
                    "Quality Assurance & Control",
                    "Logistics & Expediting",
                ],
            },
            {
                title: "Construction",
                desc: "Extensive experience managing and executing large-scale energy projects.",
                items: [
                    "Site Preparation & Civil Works",
                    "Mechanical & Piping Installation",
                    "Electrical & Instrumentation Installation",
                    "Project Management & Supervision",
                ],
            },
            {
                title: "Commissioning",
                desc: "Commissioning specialists ensure all systems and components are thoroughly tested, integrated, and optimized for peak performance before handover.",
                items: [
                    "Pre-Commissioning & Functional Testing",
                    "Integrated System Testing",
                    "Performance Testing & Optimization",
                    "Operator Training & Handover",
                ],
            },
        ],
        projectFocus: [
            {
                title: "Pembangkit Listrik Tenaga Mesin Gas (PLTMG)",
                desc: "Developing efficient and reliable gas engine power plants, including all aspects from gas supply infrastructure to power evacuation.",
            },
            {
                title: "Pembangkit Listrik Tenaga Surya (PLTS)",
                desc: "Implementing utility-scale solar photovoltaic power plants, including ground-mounted and floating solar solutions.",
            },
        ],
        specialization: {
            title: "Conquering Difficult Terrains",
            desc: "What truly sets PT. Orbito apart is our unparalleled expertise in executing projects in geographically challenging and remote areas, particularly in Eastern Indonesia (Papua and Nusa Tenggara Timur).",
            points: [
                "Extreme Geographies",
                "Challenging Soil Conditions",
                "Complex Logistics",
                "Resource Management",
                "Environmental & Social Stewardship",
            ],
        },
        whyPartner: [
            "Proven Expertise",
            "EPCC Integration",
            "Difficult Terrain Mastery",
            "Elite Human Capital",
            "Commitment to Sustainability",
            "Backed by Sadja Core Corp",
        ],
        projects: [
            { name: "SUTET 500KV Tanjung Jati – Ungaran", client: "PT PLN (Persero)", year: "2004–2005" },
            { name: "SUTT 150KV Pacitan – Ponorogo", client: "PT Percie", year: "2007–2009" },
            { name: "SUTT 150KV Timor Leste", client: "PT Tehate", year: "2011–2013" },
            { name: "SUTET 500KV Batang – Mandirancan", client: "PT Kembar Abadi", year: "2017–2019" },
            { name: "SUTET 500KV Mandirancan", client: "PT Indisi", year: "2019" },
            { name: "SUTET 500KV Tanjung Jati – Ungaran", client: "PT Percie", year: "2017–2020" },
            { name: "SUTT 150KV Singkawang", client: "PT Ayama", year: "2013–2015" },
            { name: "SUTET 500KV Palu – Poso", client: "PT Percie", year: "2010–2012" },
            { name: "SUTET 500KV Sukabumi", client: "PT Tehate", year: "2011–2013" },
            { name: "Gardu Induk Semen Indonesia", client: "PT Tehate", year: "2017–2019" },
            { name: "SUTT 150KV Pulau Selaru", client: "PT Indokarya", year: "Operational" },
            { name: "SUTET Banten – Suralaya", client: "PT BPS", year: "2012–2015" },
            { name: "SUTT Palu – Poso", client: "PT BPS", year: "High Voltage System" },
            { name: "SUTT Singkawang", client: "PT BPS", year: "West Kalimantan" },
            { name: "SUTET 500KV Tower 1–52 (23.6 KM)", client: "Samsung — Contractor: PT ETI", year: "2018–2020" },
            { name: "POWER XXI: Transmission Line 500 kV Purwodadi – Surabaya Barat", client: "PT PLN (Persero)", year: "1996" },
            { name: "Sub Marine Cable Java – Bali #2", client: "PT Pirelli Cable", year: "Ketapang – Banyuwangi, 2000" },
            { name: "Kabel Laut Tegangan Menengah 20KV Kalianget (P. Madura) – Talango (P. Poteran)", client: "PT PLN (Persero)", year: "2001–2002" },
            { name: "Proyek Stringing 500 KV Tanjung Jati B – Ungaran", client: "PT Multifab", year: "2004" },
            { name: "Rekonduktoring SUTT 150KV Pati–Rembang–Blora (PLTU 1 Jateng)", client: "PT PLN (Persero) P3B JB", year: "2006–2009" },
            { name: "150 KV and 500 KV T/L Works New Paiton East Java", client: "PT MSHE", year: "2009–2010" },
            { name: "Pembangunan T/L SUTT 150 kV Sengkang – Sidrap Section 2", client: "PT PLN (Persero)", year: "2010–2011" },
            { name: "Rekonduktoring SUTT 150 KV Kudus – Purwodadi", client: "PT PLN (Persero)", year: "2011–2015" },
            { name: "Supervisi T/L SUTT 150 KV Tenayan – Perawang", client: "PT PLN (Persero)", year: "2016–2019" },
        ],
        management: [
            { name: "Eddy Setya Budi", role: "Komisaris" },
            { name: "Bito Leilia Atmadja", role: "Direktur Utama" },
            { name: "Bima Eka Sakti", role: "Direktur Operasional 1" },
            { name: "Bambang Slamet Riyadi (Digon)", role: "Direktur Operasional 2" },
        ],
        experienceHighlights: [
            "Pembangkit Listrik Tenaga Mesin Gas (PLTMG)",
            "Pembangkit Listrik Tenaga Surya (PLTS)",
            "Testing & Commissioning",
            "Operation & Maintenance",
            "Battery Energy Storage Systems (BESS)",
        ],
        platforms: [
            {
                num: "01",
                name: "CORE EXECUTION",
                desc: "PLTMG Development, Gas-to-Power Solutions, Solar Plants, Hybrid Power Systems, and Captive Power Solutions.",
            },
            {
                num: "02",
                name: "LIFECYCLE SUPPORT",
                desc: "EPC Management, Asset Development (IPP), and Long-term O&M.",
            },
        ],
        contact: {
            email: "business@bitoatmadja.com",
            phones: ["+62 817-581-174"],
            address:
                "Jl. Jenderal Sudirman No.Kav. 86, RT.10/RW.11, Karet Tengsin, Kecamatan Tanah Abang, Kota Jakarta Pusat, Daerah Khusus Ibukota Jakarta 10220, Indonesia",
        },
    },
    {
        slug: "kharisma-damar-satya",
        route: "/companies/kharisma-damar-satya",
        cardTitle: "KHARISMA DAMAR SATYA",
        fullName: "PT. KHARISMA DAMAR SATYA",
        category: "GENERAL CONTRACTOR & CONSTRUCTION",
        tagline: "We Build For All",
        heroTitle: "PT. KHARISMA DAMAR SATYA",
        heroSubtitle: "General Contractor & Construction",
        image: "/assets/kds/cover.jpg",
        logo: "/assets/logo-damar-transparent.png",
        cardImage: "https://images.unsplash.com/photo-1479839672679-a46483c0e7c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBicmlnaHQlMjBhcmNoaXRlY3R1cmUlMjBtaW5pbWFsfGVufDB8fHx8MTc5MTQ3NjYyNnww&ixlib=rb-4.1.0&q=85&w=1200&h=800&fit=crop",
        pdf: "/downloads/PT. Kharisma Damar Satya - Company Profile.pdf",
        pdfLabel: "PT. Kharisma Damar Satya - Company Profile.pdf",
        description:
            "PT. Kharisma Damar Satya is an experienced private construction company in Indonesia with project experience across residential, office, commercial, industrial, warehouse, hospitality, infrastructure, healthcare, and real estate projects.",
        cardCapabilities: [
            "Industrial Construction",
            "Infrastructure",
            "Commercial",
            "Hospitality",
            "Residential",
            "Office",
            "Maintenance",
            "General Contracting",
        ],
        experienceHighlights: [
            "Industrial — factories and production facilities",
            "Infrastructure — Terminal 3 Soekarno-Hatta",
            "Hospitality — hotel projects",
            "Commercial buildings and developments",
            "Residential construction",
            "Office and workplace construction",
            "Maintenance capabilities",
            "Headquartered in Jakarta",
        ],
        platforms: [
            { num: "01", name: "INDUSTRIAL CONSTRUCTION" },
            { num: "02", name: "INFRASTRUCTURE" },
            { num: "03", name: "COMMERCIAL" },
            { num: "04", name: "HOSPITALITY" },
            { num: "05", name: "RESIDENTIAL" },
            { num: "06", name: "OFFICE" },
            { num: "07", name: "MAINTENANCE" },
            { num: "08", name: "GENERAL CONTRACTING" },
        ],
        contact: {
            email: "damarsatyacorp@gmail.com",
            phones: ["0817581774", "0818181774"],
            address: "Jl. Jenderal Sudirman No.86 Lantai Mezzanine, Karet Tengsin, Tanah Abang, Central Jakarta City, Jakarta 10220",
        },
    },
];

export const getCompany = (slug) => COMPANIES.find((c) => c.slug === slug);
